import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-p-confidentiality',
    templateUrl: './p-confidentiality.component.html',
    styleUrls: ['./p-confidentiality.component.css'],
    standalone: false
})
export class PConfidentialityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
